import { Injectable } from "@angular/core";
import { IActorDto } from "core/dto";
import { Observable } from "rxjs";
import { ApiService } from "../api.service";
import { controllerEndpoints } from "../controller.endpoints";
import joinUrls from "../utils.ts/join-urls";
import { ICrudBasicMethods } from "./types/i-crud-basic.methods";


@Injectable({
    providedIn: 'root'
})
export class ActorRemoteControllerService implements ICrudBasicMethods<IActorDto> {

    private _endpoint = controllerEndpoints.ACTOR

    constructor(
        private readonly _apiService: ApiService
    ) {

    }

    getOne(id: string): Observable<IActorDto> {
        const endpoint = joinUrls(this._endpoint, id);
        return this._apiService.get(endpoint);
    }

    update(id: string, updateDto: Partial<IActorDto>): Observable<IActorDto> {
        const endpoint = joinUrls(this._endpoint, id);
        return this._apiService.put(endpoint, updateDto);
    }

    create(createDto: Partial<IActorDto>): Observable<IActorDto> {

        return this._apiService.post<IActorDto>(this._endpoint, createDto);
    }

    remove(id: string): Observable<unknown> {

        const endpoint = joinUrls(this._endpoint, id);
        return this._apiService.delete(endpoint);
    }
}